import { useMemo } from 'react';
import { SortableTable } from './SortableTable';
import type { LLPStatusEvent as LLPEvent } from '@avisoma/shared/dist/ProcessingData';
import { createStableRowKey } from '../lib/stableRowKey';

export function LLPEvents({ events }: { events: LLPEvent[] }) {
  const columns = useMemo(() => {
    const keys = Object.keys(events[0] ?? {});
    return [
      {
        accessor: 'index',
        label: 'Index',
        render: (_row: LLPEvent, index: number) => index + 1,
      },
      ...keys.map((key) => ({
        accessor: key,
        label: key,
      })),
    ];
  }, [events]);

  const data = useMemo(() => {
    return events.sort((a, b) => new Date(a.date ?? 0).getTime() - new Date(b.date ?? 0).getTime());
  }, [events]);

  if (!data.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">LLP Events ({events.length})</h2>
      <div className="overflow-hidden rounded-lg">
        <SortableTable storageId="llp-events" columns={columns} data={data} rowKey={createStableRowKey(data)} />
      </div>
    </div>
  );
}
